module.exports = __webpack_public_path__ + "static/nova-polhora-f60b4a0510b3cbe39e319e7b3eab41c7.svg";